module.exports = __webpack_public_path__ + "img/img-24.2eac9255.png";